export const FAILED_ACTION = 'FAILED_ACTION';
export const SUCCESS_ACTION = 'SUCCESS_ACTION';
export const CLEARED_MESSAGE = 'CLEARED_MESSAGE';
